import { AboutPage } from '@/app/pages/AboutPage';

export function ResponsiveAboutPage() {
  return <AboutPage />;
}
